import { Button } from '@/components/ui/button'
import { Link } from 'react-router-dom'
import { type Language } from './LandingPage'
import { PinDayLogo } from '@/components/ui/PinDayLogo'

const content = {
  pt: {
    tagline: 'Reserve datas com cobrança clara, política registrada e fila de espera Pro+.',
    cta: 'Criar conta',
    product: 'Produto',
    legal: 'Legal',
    links: {
      howItWorks: 'Como funciona',
      pricing: 'Pricing',
      faq: 'FAQ',
      login: 'Entrar',
      register: 'Cadastrar',
      privacy: 'Privacidade',
      terms: 'Termos',
      cookies: 'Cookies',
    },
  },
  en: {
    tagline: 'Reserve dates with clear billing, recorded policy, and a Pro+ waitlist.',
    cta: 'Create account',
    product: 'Product',
    legal: 'Legal',
    links: {
      howItWorks: 'How it works',
      pricing: 'Pricing',
      faq: 'FAQ',
      login: 'Login',
      register: 'Register',
      privacy: 'Privacy',
      terms: 'Terms',
      cookies: 'Cookies',
    },
  },
  es: {
    tagline: 'Reserva fechas con cobro claro, política registrada y lista de espera Pro+.',
    cta: 'Crear cuenta',
    product: 'Producto',
    legal: 'Legal',
    links: {
      howItWorks: 'Cómo funciona',
      pricing: 'Pricing',
      faq: 'FAQ',
      login: 'Entrar',
      register: 'Registro',
      privacy: 'Privacidad',
      terms: 'Términos',
      cookies: 'Cookies',
    },
  },
}

interface FooterProps {
  language: Language
}

export function Footer({ language }: FooterProps) {
  const t = content[language]
  const localeBase = `/${language}`

  return (
    <footer className="border-t border-[#0b2a4a]/10 bg-white px-6 py-16">
      <div className="mx-auto max-w-7xl">
        <div className="grid gap-10 lg:grid-cols-[1.2fr_0.8fr_0.8fr]">
          <div>
            <PinDayLogo size="lg" />
            <p className="mt-4 max-w-md text-base leading-7 text-[#0b2a4a]/72">{t.tagline}</p>
            <Link to={`${localeBase}/register`} className="mt-6 inline-block">
              <Button className="bg-[#f08a24] text-white hover:bg-[#f08a24]/90">{t.cta}</Button>
            </Link>
          </div>

          <div>
            <h3 className="text-sm font-semibold uppercase tracking-[0.22em] text-[#0b2a4a]/44">{t.product}</h3>
            <div className="mt-4 space-y-3 text-sm text-[#0b2a4a]/72">
              <a href="#how-it-works">{t.links.howItWorks}</a>
              <br />
              <a href="#pricing">{t.links.pricing}</a>
              <br />
              <a href="#faq">{t.links.faq}</a>
              <br />
              <Link to={`${localeBase}/login`}>{t.links.login}</Link>
              <br />
              <Link to={`${localeBase}/register`}>{t.links.register}</Link>
            </div>
          </div>

          <div>
            <h3 className="text-sm font-semibold uppercase tracking-[0.22em] text-[#0b2a4a]/44">{t.legal}</h3>
            <div className="mt-4 space-y-3 text-sm text-[#0b2a4a]/72">
              <Link to={`${localeBase}/privacy`}>{t.links.privacy}</Link>
              <br />
              <Link to={`${localeBase}/terms`}>{t.links.terms}</Link>
              <br />
              <Link to={`${localeBase}/cookies`}>{t.links.cookies}</Link>
            </div>
          </div>
        </div>
        <div className="mt-10 border-t border-[#0b2a4a]/10 pt-6 text-sm text-[#0b2a4a]/56">
          © 2026 PinDay
        </div>
      </div>
    </footer>
  )
}
